export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LcMwzwtAAAAADFnqC02LhMINDdBq6YHwoZpIXXe',
  },

  // baseUrl: 'https://localhost:7249/api/'
  // baseUrl: 'https://edgiosecuritieslitigation-claimform-dev.azurewebsites.net/api/'
  baseUrl: 'https://edgiosecuritieslitigation-claimform.azurewebsites.net/api/'
};

